import React from "react";
import favIcon from "assets/images/cowva-favicon.svg";

import menu from "assets/icons/menu-btn.svg";
import search from "assets/icons/search.svg";
import bell from "assets/icons/bell.svg";
import dummy from "assets/images/user.png";
import { useMenuToggler } from "hooks/useMenuToggler";
import MobileSidebar from "../../sidebar/mobile";
import { useUser } from "hooks";

export default function MobileHeader() {
  const { openMenu } = useMenuToggler();
  const { user } = useUser();

  return (
    <header className="h-[64px] w-full flex justify-between items-center px-4 shadow-[0px_4px_40px_0px_rgba(0,_0,_0,_0.15)] relative">
      <div className="flex gap-2">
        <img src={favIcon} alt="Cowva" className="h-[48px] w-[48px]" />
        <img
          src={menu}
          alt="Handlense"
          className="cursor-pointer"
          onClick={openMenu}
        />
        <img src={search} alt="Handlense" />
      </div>
      <div className="flex gap-2">
        <img src={bell} alt="" />
        <img
          src={user?.profilePic ?? dummy}
          alt={user?.firstname}
          title={user?.firstname}
          className="h-[33px] w-[33px] object-cover"
        />
      </div>
      <MobileSidebar />
    </header>
  );
}
